<template>
    <div>
        <page-header :title="$t('semester_status')"
                     @filter-div-status="datatable.filterStatus=$event"
                     :isFilter="false"
                     :isColumns="true">
            <template v-slot:columns>
                <div class="mb-1" v-for="(column,i) in datatable.columns" :key="i">
                    <b-form-checkbox
                        :id="'checkbox-'+i"
                        :name="'checkbox-'+i"
                        :value="false"
                        :unchecked-value="true"
                        v-model="column.hidden"
                        v-if="column.field!='buttons'"
                    >
                        {{ br2space(column.label) }}
                    </b-form-checkbox>
                </div>
            </template>
        </page-header>

        <datatable :rows="datatable.rows"
                   :columns="datatable.columns"
                   :query-params="datatable.queryParams"
                   v-show="datatable.showTable"
                   :is-loading="datatable.isLoading"
                   @on-page-change="onPageChange"
                   @on-per-page-change="onPerPageChange"
                   :title="''"
        />
    </div>
</template>
<script>
// Template
import PageHeader from '@/components/page/PageHeader';

// Component
import Datatable from '@/components/datatable/Datatable';

// Pages

// Services
import StudentProgramService from "@/services/StudentProgramService";

// Other
import qs from "qs";

export default {
    components: {
        PageHeader,
        Datatable,
    },
    props: {
        studentProgram: {}
    },
    data() {
        return {
            formId: null,
            formProcess: null,

            datatable: {
                rows: [],
                showTable: true,
                isLoading: false,
                total: 0,
                queryParams: {
                    filter: {},
                    limit: 20,
                    page: 1
                },
                columns: [
                    {
                        field: 'academic_year',
                        label: this.toUpperCase(this.toUpperCase('academic_year')),
                        hidden: false,
                        sortable: false,
                        thClass: 'text-center',
                        tdClass: 'text-center'
                    },
                    {
                        field: 'semester',
                        label: this.toUpperCase(this.toUpperCase('semester')),
                        hidden: false,
                        sortable: false,
                        thClass: 'text-center',
                        tdClass: 'text-center'
                    },
                    {
                        field: 'semester_status_name',
                        label: this.toUpperCase(this.toUpperCase('semester_status_name')),
                        hidden: false,
                        sortable: false,
                        thClass: 'text-center',
                        tdClass: 'text-center'
                    },
                ]
            }
        }
    },
    mounted() {
        this.filterClear();
    },
    methods: {
        filter() {
            this.datatable.queryParams.page = 1;
            this.getRows()
        },
        filterClear() {
            this.filterSet();
            this.getRows()
        },
        filterSet() {
            var keys = Object.keys(this.datatable.queryParams.filter)
            for (var i = 0; i < keys.length; i++) {
                let key = keys[i]
                this.datatable.queryParams.filter[key] = null;
            }
        },
        onPageChange(params) {
            this.datatable.queryParams.page = params.currentPage
        },
        onPerPageChange(params) {
            this.datatable.queryParams.limit = params.currentPerPage;
        },
        getRows() {
            let config = {
                params: {
                    filter:
                        {
                            student_program_id: this.studentProgram.id
                        }
                },
                paramsSerializer: params => qs.stringify(params, { encode: false })
            }

            this.datatable.showTable = true;
            this.datatable.isLoading = true;

            return StudentProgramService.studentSemester(config)
                .then(response => {
                    let data = response.data.data;
                    this.datatable.rows = data;
                    this.datatable.total = response.data.pagination.total;
                })
                .catch((e) => {
                    this.showErrors(e)
                })
                .finally(() => {
                    this.datatable.isLoading = false
                })
        },
    }
}
</script>
